window.klira = {}